import { LocalStorageKeys } from "@/common/browserStorage/constants";

export function getStorageValue<T = string>(
  key: LocalStorageKeys,
  fallbackValue: T,
): T {
  try {
    const value = localStorage.getItem(key);
    if (value) {
      try {
        return JSON.parse(value);
      } catch {
        return value as T;
      }
    }
    if (!value) {
      localStorage.setItem(key, JSON.stringify(fallbackValue));
    }
    return fallbackValue;
  } catch (error) {
    throw Error(JSON.stringify(error));
  }
}

export function setStorageValue<T = unknown>(
  key: LocalStorageKeys,
  value: T,
): void {
  try {
    // TODO: wrong implementation (dont use)
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    throw Error(JSON.stringify(error));
  }
}

export function clearStorage(key?: LocalStorageKeys) {
  try {
    if (key) {
      localStorage.removeItem(key);
      return;
    }
    localStorage.clear();
  } catch (error) {
    throw Error(JSON.stringify(error));
  }
}
